import { Line, Layer } from 'react-konva';
import { useImageEditorStore } from '../ImageEditorStoreProvider';
import type { AllStoreType } from '../store/imageEditor.type';
import { useRef, forwardRef, useEffect } from 'react';
import { Layer as KonvaLayer } from 'konva/lib/Layer';
interface MaskLayerProps {
  onExport?: (dataUrl: string) => void;
}

export interface MaskLayerHandle {
  exportMask: () => void;
}

const MaskLayer = forwardRef<MaskLayerHandle, MaskLayerProps>(() => {
  const { lines, setLayerRef } = useImageEditorStore<AllStoreType>(
    (state) => state
  );
  const layerRef = useRef<KonvaLayer>(null);

  useEffect(() => {
    if (layerRef.current && setLayerRef) {
      setLayerRef(layerRef.current);
    }
  }, [setLayerRef]);

  return (
    <Layer ref={layerRef}>
      {Object.entries(lines || {}).map(([key, value]) => (
        <Line
          key={key}
          id={key}
          stroke="#df4b26"
          strokeWidth={value.strokeWidth}
          lineCap="round"
          lineJoin="round"
          opacity={value.globalCompositeOperation === 'source-over' ? 0.6 : 1}
          globalCompositeOperation={value.globalCompositeOperation}
          points={value.points}
          tension={1}
        />
      ))}
    </Layer>
  );
});

MaskLayer.displayName = 'MaskLayer';

export { type MaskLayerProps, MaskLayer as default };
